import React from 'react';
import type { ReactNode } from 'react';
import styled from 'styled-components';
import 'normalize.css';
import GlobalStyles from '../styles/GlobalStyles';
import LayoutStyles from '../styles/LayoutStyles';
import Typography from '../styles/Typography';
import type { PageContext } from '../types';
import Fonts from './Fonts';
import Footer from './Footer';
import Header from './Header';

interface LayoutProps {
  children: ReactNode;
  pageContext: PageContext;
}

const ContentStyles = styled.main`
  max-width: 850px;
  margin: 0 auto;
  padding: 3rem 2rem;

  @media (max-width: 850px) {
    max-width: 100%;
    padding: 3rem 10%;
  }
`;

export default function Layout({ children, pageContext }: LayoutProps) {
  return (
    <>
      <GlobalStyles />
      <Fonts />
      <Typography />
      <LayoutStyles>
        <Header pageContext={pageContext} />
        <ContentStyles>{children}</ContentStyles>
        <Footer pageContext={pageContext} />
      </LayoutStyles>
    </>
  );
}
